/* Copyright (c) 2017 Backpack Health LLC */

import { types as listActionTypes } from 'redux/actions/lists';

const initialState = {
  isFetching: false,
  collection: [],
};

export function reducer(state = initialState, action = {}) {
  switch (action.type) {
    case listActionTypes.LIST_LOCALE_REQUEST:
    case listActionTypes.LIST_LOCALE_RECEIVE:
      return _.assign({}, state, action.payload);
    default:
      return state;
  }
}


function getClosestMatchingLocaleId(state, clientRegionalLanguages) {
  let exactMatchIndex = -1;
  let matchedLocale;
  const supportedLocaleList = [...state.lists.locale.collection];
  supportedLocaleList.sort((a, b) => a.id - b.id); // sort by ids so that first defined locale will be default

  const regions = clientRegionalLanguages.map(l => l.split('-')[0]);

  for (let i = 0; i < clientRegionalLanguages.length; i++) {
    const matches = supportedLocaleList.filter((l) => l.language_region === clientRegionalLanguages[i]);
    if (exactMatchIndex < 0 && matches.length > 0) {
      exactMatchIndex = i;
      matchedLocale = matches[0];
      break;
    }
  }

  for (let i = 0; i < regions.length; i++) {
    const matches = supportedLocaleList.filter((l) => l.language_region.split('-')[0] === regions[i]);
    if (matches.length > 0) {
      if (exactMatchIndex < 0 || i < exactMatchIndex) {
        matchedLocale = matches[0];
        break;
      }
    }
  }

  if (matchedLocale) {
    return matchedLocale.id;
  } else {
    return supportedLocaleList[0] ? supportedLocaleList[0].id : null;
  }
}

const selectors = {
  getCollection: state => state.lists.locale.collection,
  getLocale: (state, localeId) => (state.lists.locale.collection.filter(l => l.id === localeId)[0] || {}),
  getClosestMatchingLocaleId,
  getLocaleByLanguageCode: (state, languageCode) => (state.lists.locale.collection.filter(l => l.language_code === languageCode)[0] || {}),
};

export default selectors;
